import React, { useMemo, useState } from 'react';
import { filterCallsByDate, buildAgentStats, formatAvgDuration } from './callUtils';
import DateRangePicker from './DateRangePicker';

function AgentDetails({ calls, onSelectAgent }) {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const filteredCalls = useMemo(
    () => filterCallsByDate(calls, fromDate, toDate),
    [calls, fromDate, toDate]
  );
  const agents = useMemo(() => buildAgentStats(filteredCalls), [filteredCalls]);
  const hasFilter = Boolean(fromDate || toDate);

  const clearFilter = () => {
    setFromDate('');
    setToDate('');
  };

  return (
    <div className="agent-page">
      <div className="agent-page-header">
        <h2 className="agent-page-title">Agent Details</h2>
        <div className="agent-date-filter">
          <DateRangePicker
            fromDate={fromDate}
            toDate={toDate}
            onApply={(from, to) => {
              setFromDate(from);
              setToDate(to);
            }}
          />
          {hasFilter && (
            <button type="button" className="agent-date-filter-clear" onClick={clearFilter}>
              Clear
            </button>
          )}
        </div>
      </div>
      <p className="agent-page-summary">
        {filteredCalls.length} call{filteredCalls.length === 1 ? '' : 's'}
        {hasFilter ? ' in selected range' : ' total'}
      </p>
      {agents.length === 0 ? (
        <p className="agent-page-empty">
          {hasFilter ? 'No agent-handled calls in this date range.' : 'No agent-handled calls yet.'}
        </p>
      ) : (
        <div className="agent-list">
          {agents.map((agent) => {
            return (
              <button
                key={agent.key}
                type="button"
                className="agent-row"
                onClick={() => onSelectAgent && onSelectAgent(agent.name)}
                title={`View saved queries for ${agent.name}`}
              >
                <div className="agent-row-identity">
                  <span className="agent-avatar">{agent.name.charAt(0).toUpperCase()}</span>
                  <div className="agent-row-name-block">
                    <span className="agent-name">{agent.name}</span>
                    {agent.number !== '-' && <span className="agent-number">{agent.number}</span>}
                  </div>
                </div>
                <div className="agent-row-stats">
                  <div className="agent-stat">
                    <span className="agent-stat-value">{agent.answered}</span>
                    <span className="agent-stat-label">Answered</span>
                  </div>
                  <div className="agent-stat">
                    <span className="agent-stat-value">{agent.totalCalls}</span>
                    <span className="agent-stat-label">Total Calls</span>
                  </div>
                  <div className="agent-stat">
                    <span className="agent-stat-value">
                      {formatAvgDuration(agent.totalBillsec, agent.answered)}
                    </span>
                    <span className="agent-stat-label">Avg Duration</span>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default AgentDetails;
